import type { GapClientInfo } from "@/types/gap-client"

// Static client/venue mapping - in production this would come from an API
// This maps clientId to client information for display purposes
export const clientInfoMap: Record<string, GapClientInfo> = {
  "acme-downtown": { id: "acme-downtown", name: "Acme Corp", venue: "Downtown HQ", venueId: 1 },
  "techstart-west": { id: "techstart-west", name: "TechStart Inc", venue: "West Campus", venueId: 2 },
  "global-east": { id: "global-east", name: "Global Media", venue: "East Wing", venueId: 3 },
  "acme-remote": { id: "acme-remote", name: "Acme Corp", venue: "Remote Office", venueId: 4 },
  "techstart-main": { id: "techstart-main", name: "TechStart Inc", venue: "Main Building", venueId: 5 },
  "global-studio": { id: "global-studio", name: "Global Media", venue: "Studio A", venueId: 6 },
  "retail-store42": { id: "retail-store42", name: "Retail Plus", venue: "Store #42", venueId: 7 },
  "finance-trading": { id: "finance-trading", name: "Finance Hub", venue: "Trading Floor", venueId: 8 },
}

// Get all unique clients for filter dropdowns
export function getUniqueClients(): { id: string; name: string }[] {
  const seen = new Set<string>()
  const clients: { id: string; name: string }[] = []

  Object.values(clientInfoMap).forEach((info) => {
    if (!seen.has(info.name)) {
      seen.add(info.name)
      clients.push({ id: info.name.toLowerCase().replace(/\s+/g, "-"), name: info.name })
    }
  })

  return clients
}

// Get all venues for filter dropdowns
export function getVenues(): { id: string; name: string }[] {
  return Object.values(clientInfoMap).map((info) => ({
    id: info.id,
    name: info.venue,
  }))
}

// Get client info by clientId
export function getClientInfo(clientId: string): GapClientInfo | undefined {
  return clientInfoMap[clientId]
}

// Client options for forms
export const clientOptions = Object.values(clientInfoMap).map((info) => ({
  value: info.id,
  label: info.name,
  venue: info.venue,
}))
